import React, { useEffect, useState } from 'react';
import apiClient from '../utils/apiClient';
import CertificateForm from '../components/CertificateForm';
import './certificates.css';

const CertificatePage = () => {
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingCert, setEditingCert] = useState(null);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchCerts();
  }, []);

  const fetchCerts = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get('/certifications');
      setCerts(res.data || []);
    } catch {
      setError('Failed to load certifications');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (data) => {
    try {
      if (editingCert) {
        const res = await apiClient.put(
          `/certifications/${editingCert.id}`,
          data
        );
        setCerts(certs.map(c => c.id === editingCert.id ? res.data : c));
        setSuccess('Certification updated');
      } else {
        const res = await apiClient.post('/certifications', data);
        setCerts([...certs, res.data]);
        setSuccess('Certification added');
      }
      setShowModal(false);
      setEditingCert(null);
      setTimeout(() => setSuccess(''), 2500);
    } catch {
      setError('Failed to save certification');
    }
  };

  const handleDelete = async (cert) => {
    if (!window.confirm(`Delete "${cert.title}"?`)) return;

    try {
      await apiClient.delete(`/certifications/${cert.id}`);
      setCerts(certs.filter(c => c.id !== cert.id));
    } catch {
      setError('Failed to delete certification');
    }
  };

  return (
    <div className="admin-page">
      <div className="content-header">
        <h2>🎓 Certifications</h2>
        <button
          className="add-btn"
          onClick={() => {
            setEditingCert(null);
            setShowModal(true);
          }}
        >
          + Add Certification
        </button>
      </div>

      {success && <div className="alert success">{success}</div>}
      {error && <div className="alert error">{error}</div>}

      {loading ? (
        <div className="no-data">Loading certifications…</div>
      ) : certs.length === 0 ? (
        <div className="no-data">No certifications yet</div>
      ) : (
        <div className="cert-grid">
          {certs.map(cert => (
            <div key={cert.id} className="cert-card">
              <h4>{cert.title}</h4>
              {cert.issuer && <p className="issuer">{cert.issuer}</p>}
              {cert.issued_at && (
                <p className="date">📅 {cert.issued_at}</p>
              )}
              {cert.link && (
                <a href={cert.link} target="_blank" rel="noreferrer">
                  View Certificate →
                </a>
              )}

              <div className="actions">
                <button
                  className="edit-btn"
                  onClick={() => {
                    setEditingCert(cert);
                    setShowModal(true);
                  }}
                >
                  Edit
                </button>
                <button
                  className="delete-btn"
                  onClick={() => handleDelete(cert)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <CertificateForm
              certificate={editingCert}
              onSave={handleSave}
              onCancel={() => setShowModal(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CertificatePage;
